import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { getAssistiveTextFromColorClass } from '../../utils/accessibility.js';
import ButtonIcon from '../ButtonIcon/index.js';

const renderDismissButton = (onDismiss, testSection) => {
  return /* @__PURE__ */ jsx("div", { className: "oui-attention__close", children: /* @__PURE__ */ jsx(
    ButtonIcon,
    {
      "aria-label": "Close alert",
      iconName: "xmark",
      onClick: onDismiss,
      size: "small",
      style: "plain",
      testSection: `${testSection}-dismiss`
    }
  ) });
};
const Attention = ({
  alignment = "left",
  children,
  className,
  onDismiss,
  testSection,
  type = "brand",
  ...props
}) => {
  const classes = classNames(
    "oui-attention",
    `oui-attention--${type}`,
    `oui-text--${alignment}`,
    className
  );
  const attentionAriaLabel = getAssistiveTextFromColorClass(type);
  const dismissBtn = onDismiss ? renderDismissButton(onDismiss, testSection) : null;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      "aria-label": attentionAriaLabel,
      className: classes,
      "data-oui-component": true,
      "data-test-section": testSection,
      role: "alert",
      ...props,
      children: [
        /* @__PURE__ */ jsx("div", { className: "oui-attention__content", children }),
        dismissBtn
      ]
    }
  );
};

export { Attention as default };
